"use strict";

App.Pages.Stats = class Stats extends PF.Page
	{

	static get options()
		{
		return {
			rights: {
				user: true
			},
			path: '/stats',
			nameRu: 'Статистика',
		};
		}

	static get template()
		{
		//language=HTML
		return `
			<div class="page navbar-fixed">

				<div class="page-content ptr-content" pf="pageContent">

					<div class="page-header">
						<h3>Статистика</h3>
					</div>
					<div class="stretch-block">
						<div class="card list" style="padding: 0;">
							<ul>
								<li>
									<a href="/stat-stellas" class="item-link item-content panel-close">
										<div class="item-media"><i class="material-icons">timeline</i></div>
										<div class="item-inner">
											<div class="item-title">Статистика по детекциям</div>
										</div>
									</a>
								</li>
								<li>
									<a href="/stat-emotion" class="item-link item-content panel-close">
										<div class="item-media"><i class="material-icons">timeline</i></div>
										<div class="item-inner">
											<div class="item-title">Статистика Эмоций</div>
										</div>
									</a>
								</li>
								<li>
									<a href="/stat-emotion-map" class="item-link item-content panel-close">
										<div class="item-media"><i class="material-icons">maps</i></div>
										<div class="item-inner">
											<div class="item-title">Статистика Эмоций - карта</div>
										</div>
									</a>
								</li>
							</ul>
						</div>
					</div>
				</div>

		`;
		}


	init()
		{
		super.init();

		}
	};
